import React from 'react'
import {Outlet, useNavigate} from 'react-router-dom'

import {StaffSidebarNav} from './StaffSidebarNav'

import {Layout} from '~/components/layout/Layout'

export const StaffManagementPage: React.FC = () => {
  const navigate = useNavigate()
  const fullPath = '/app/staff/'

  return (
    <Layout
      sideNav={
        <StaffSidebarNav
          fullPath={fullPath}
          onClick={(id) => navigate(`${fullPath}${id}`)}
        />
      }
      navMenu={null}>
      <Outlet />
    </Layout>
  )
}
